<template>
  <div>
    <textarea-field
      v-model="textareaValue"
      :label="name"
      type="textarea"
      :name="name"
      placeholder="400文字以内でご要望・ご質問内容をご入力ください。"
      :validator="validator"
      :message="message"
    />
    <error-message :name="name" />
  </div>
</template>

<script setup>
import { watch } from 'vue';
import TextareaField from './form/element/textarea';
import ErrorMessage from '@component_path/pages/pc/positions/show/common_components/form_element/ErrorMessage';
import { useMessageField } from '@component_path/inquiry_form_common_module/custom_hook/Message';

const emit = defineEmits(['change']);
const textareaValue = defineModel('textareaValue');

const props = defineProps({
  message: {
    type: String,
    required: true
  }
});

const { fieldName: name, validator } = useMessageField(true, {
  max: 'コメントは400文字以内にしてください',
  requirement: 'コメントは必須項目です'
});

watch(textareaValue, newValue => {
  emit('change', 'message', newValue);
});
</script>
